import { request } from '@remote/api/request'
import WebsocketClient, { createWSConf } from '@remote/utils/socket'
import {
  guid,
  readAsText,
  sendMQTTMessage,
} from '@remote/api/adapter/helper'
import { IRequestInterceptorParams } from '@remote/api/adapter/index.d'

interface IGetJobInfoParams {
  /** 业务id */
  biz: string
  /** 设备ID，v1接口为必填 */
  device_id?: string
  /** 用户id，v2接口必填 */
  user_id?: string | number
  /** 用于精确查询 */
  job_ids?: string[]
  /** 状态：空 进行中；1 完成； */
  status?: number
  /** 分页页码，默认1 */
  page?: number
  /** 分页数量，默认10 */
  page_nums?: number
  /** 默认空，分页查询用，v2支持 */
  page_token?: string
  group_id?:string
}

export interface IJobInfo {
  biz: string
  job_id: string
  name: string
  device_id: string
  app_id: string
  progress: number
  expire_at: string
  status: number
  ext_data: string
}

export interface IJobInfoResponse {
  total: number
  page_token: string
  list: IJobInfo[]
}

export function getJobInfo (params: IGetJobInfoParams, options?: IRequestInterceptorParams['options']) {
  const url = '/api/v2/job/get_info'
  return request(url, params, Object.assign({
    method: 'POST',
  }, options)).catch(err => {
    console.error(err)
    throw err
  })
}

export interface IPollOptions {
  onCheck: (jobs: IJobInfo[]) => ([string, boolean])
  timeout?: number
  timeoutMessage?:string
  interval?: number
  leading?: boolean
}
export interface IPoll2queryJobparams {
  biz: string
  jobIds?: string[]
  options: IPollOptions
  userid?: string | number
  device_id: string
  group_id?:string
  page_nums?: number
  status?:number
}

export function eraseJob (params: { biz: string; job_id: string[]; device_id }, options?: IRequestInterceptorParams['options']) {
  const url = '/api/v1/job/delete'
  return request(url, params, Object.assign({
    method: 'POST',
    apiEnv: 'heziProduction',
  }, options ))
}

export async function poll2queryJob (params: IPoll2queryJobparams, reqOptions: IRequestInterceptorParams['options'] = {}): Promise<IJobInfo[]> {
  const { device_id, userid, biz, jobIds, options, group_id, page_nums, status } = params
  const { timeout = 2 * 60 * 1000, timeoutMessage = '链接解析超时', interval = 5 * 1000, leading = false, onCheck } = options
  return new Promise((resolve, reject) => {
    const startTime = Date.now()

    let timer: NodeJS.Timer | null = null
    function check () {
      getJobInfo({
        device_id, 
        user_id: userid, 
        biz, job_ids: jobIds, 
        page_nums: page_nums || jobIds?.length,
        group_id,
        status,
      }, reqOptions)
        .then((res) => {
          const [err, { data }] = res
          console.log('getJobInfo', res)
          if (!err && data?.list?.length) {
            const { list } = data
            const jobs = Array.isArray(list) ? list : []
            const targetJobs = jobIds?.length ? jobs.filter(t => jobIds?.includes(t.job_id)) : jobs

            if (targetJobs && targetJobs.length) {
              const [errorMsg, isResolved] = onCheck(targetJobs)
              if (errorMsg) {
                reject(errorMsg)
                // eraseJob({ biz, device_id, job_id: jobIds }, reqOptions)
                if (timer) clearInterval(timer)
              }

              if (isResolved) {
                resolve(targetJobs)
                // eraseJob({ biz, device_id, job_id: jobIds }, reqOptions)
                if (timer) clearInterval(timer)
              }
            }
          }
        })
    }
    timer = setInterval(() => {
      const now = Date.now()
      if (timeout > 0 &&  now - startTime > timeout) {
        reject(timeoutMessage)
        if (timer) clearInterval(timer)
      }
      check()
    }, interval)
    if (leading) {
      check()
    }
  })
}

/**
 * 根据路径读取XOS设备上的文件内容，以text形式返回
 * @param fullFilePath 设备上的文件路径（全路径）
 * @param mqttConfig MQTT的相关配置
 * @returns String 文件内容
 */
export async function readFile (fullFilePath: string, deviceId: string) {
  const { url, wsServerQuery, wsWebQuery } = await createWSConf(deviceId)

  const socket = new WebsocketClient({ url, query: wsWebQuery })
  socket.init()
  return new Promise<string>((resolve, reject) => {
    const onmessage = (e: MessageEvent) => {
      if (e.data instanceof Blob) {
        // const blobUrl = window.URL.createObjectURL(e.data)
        // const dlDom = window.document.createElement('a')
        // dlDom.href = blobUrl
        // dlDom.setAttribute('download', `bt_${Date.now()}.txt`)
        // dlDom.click()
        // window.URL.revokeObjectURL(blobUrl)

        readAsText(e.data).then(ftxt => {
          // console.log('[ReadXOSFile]文件内容:', ftxt.length, ftxt)
          resolve(ftxt)
          socket.removeAllEventListener('message')
          socket.removeAllEventListener('error')
          socket.close()
        }).catch(err => {
          socket.close()
          console.log('[ReadXOSFile]Error:', err)
          reject(err)
        })
      }
    }
    socket && socket.addEventListener('message', onmessage)
    socket && socket.addEventListener('error', (errMessage: string) => {
      console.log('[ReadXOSFile][ws]Error:', errMessage)
    })

    const session_id = guid()
    const params = {
      path: fullFilePath,
      conn: [url + wsServerQuery],
      session_id,
      chunksize: 20 * 1024 * 1024,
      ver: 1139,
    }
    // console.log('[ReadXOSFile]:', fullFilePath, params)
    sendMQTTMessage('xl_shell', 'download', params).catch(err => {
      reject(err)
      socket.close()
    })
  })
}